import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import FileUpload from 'components/sales/fileUpload/fileUpload';

export const AddFollowUp = ({
  data,
  handleValue,
  match,
  documentUploadUrl,
  documentUrlData,
}) => {
  const copResidentialfollowUp = {
    lead_id: '',
    last_call_date: '',
    interaction_type: '',
    // deal_status: '',
    remarks: '',
    status: '',
    next_step: '',
    next_action_date: '',
    expected_closure: '',
    meeting_align_date: '',
    sites_id: '',
    other_emals: '',
    poc_id: '',
    document: '',
    lead_drop_reason: '',
  };

  const [copResidentialData, setCopResidentialData] = useState(
    copResidentialfollowUp
  );
  const [leadId, setleadId] = useState();
  const [isFocus1, setIsFous1] = useState(true);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);
  const [isFocus4, setIsFous4] = useState(false);
  const [isDemand, setIsDemand] = useState(null);

  useEffect(() => {
    setleadId(match.params.id);
    setCopResidentialData({ ...copResidentialData, lead_id: leadId });
  }, []);

  useEffect(() => {
    setCopResidentialData({ ...copResidentialData, lead_id: leadId });
  }, [leadId]);

  const handleFormData = () => {
    let isValue = true;
    for (const key in copResidentialData) {
      if (
        key !== 'remarks' &&
        key !== 'next_step' &&
        key !== 'sites_id' &&
        key !== 'other_emals' &&
        key !== 'document' &&
        key !== 'meeting_align_date' &&
        key !== 'lead_drop_reason'
      ) {
        if (!copResidentialData[key]) {
          isValue = false;
        }
      }
    }
    isValue ? handleValue({ ...copResidentialData }) : handleValue(null);
  };

  useEffect(() => {
    handleFormData();
  }, [copResidentialData]);

  useEffect(() => {
    const selectedDate = new Date();
    setCopResidentialData({
      ...copResidentialData,
      last_call_date: selectedDate,
    });
  }, []);

  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    setCopResidentialData({
      ...copResidentialData,
      last_call_date: selectedDate,
    });
  };

  const handleDateChange2 = (date, dateString) => {
    const selectedDate = dateString;
    setCopResidentialData({
      ...copResidentialData,
      next_action_date: selectedDate,
    });
  };

  const handleDateChange3 = (date, dateString) => {
    const selectedDate = dateString;
    setCopResidentialData({
      ...copResidentialData,
      expected_closure: selectedDate,
    });
  };

  const handleDateChange4 = (date, dateString) => {
    const selectedDate = dateString;
    setCopResidentialData({
      ...copResidentialData,
      meeting_align_date: selectedDate,
    });
  };
 

  const handleDateHide1 = () => {
    if (!copResidentialData.last_call_date) {
      setIsFous1(true);
    }
  };
  const handleDateHide2 = () => {
    if (!copResidentialData.next_action_date) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!copResidentialData.expected_closure) {
      setIsFous3(true);
    }
  };

  const handleDateHide4 = () => {
    if (!copResidentialData.meeting_align_date) {
      setIsFous4(true);
    }
  };

  const handleDemand = ({ id, value }) => {
    setIsDemand(id);
    setCopResidentialData({
      ...copResidentialData,
      status: id,
    })
  }
  const handleSupplyName = () => {
    if (isDemand === 27) {
      return (
          <DropDownInput
            data={data && data.lead_drop_reason}
            label={localization.leadDropReason}
            required
            isStarRequired={true}
            getIdValue={(val) =>
              setCopResidentialData({
                ...copResidentialData,
                lead_drop_reason: val.id,
              })
            }
          />
      );
    }
    if(isDemand === 17){
      return (
        <FormGroup
        className={`date custom_date_picker ${isFocus4 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDateChange4}
          onShow={() => setIsFous4(true)}
          onHide={handleDateHide4}
          onClear={() => setIsFous4(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          minDate={new Date()}
        />
        <label>
          {localization.meetingAlignedData}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus2 && (
          <label className="error date_error">
            {localization.meetingAlignedData}
          </label>
        )}
      </FormGroup>
      );
    }
  };


  return (
    <FormSection title={localization.addFollowUpDetails}>
      <FormGroup
        className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDateChange1}
          onShow={() => setIsFous1(true)}
          onHide={handleDateHide1}
          onClear={() => setIsFous1(false)}
          value={copResidentialData.last_call_date}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          maxDate={new Date()}
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
        />
        <label>
          {localization.lastInteractionDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus1 && (
          <label className="error date_error">
            {localization.requiredLastInterdate}
          </label>
        )}
      </FormGroup>
      <DropDownInput
        data={data && data.interaction_type}
        label={localization.interactionType}
        required
        isStarRequired={true}
        errorMsg={localization.requiredInteractionType}
        getIdValue={(val) =>
          setCopResidentialData({
            ...copResidentialData,
            interaction_type: val.id,
          })
        }
      />
      

      <ConstantInput
        type="text"
        label={localization.NotesRemarks}
        handleChange={(val) => {
          setCopResidentialData({
            ...copResidentialData,
            remarks: val,
          });
        }}
      />
    {/* <DropDownInput
            data={data && data.deal_status}
            label={localization.dealStatus}
            required
            isStarRequired={true}
            errorMsg={localization.requiredDealStatus}
            getIdValue={(val) =>
              setCopResidentialData({
                ...copResidentialData,
                deal_status: val.id,
              })
            }
          /> */}
      <DropDownInput
        data={data && data.followup_status}
        label={localization.currentStatus}
        getIdValue={(val) => handleDemand(val)}
        required
        isStarRequired={true}
        errorMsg={localization.requiredCurrentStatus}
      />

      {handleSupplyName()}

      <DropDownInput
        data={data && data.poc_details}
        label={localization.addPOCButton}
        required
        isStarRequired={true}
        multipule
        errorMsg={localization.requiredPoc}
        getIdValue={(val) => {
          if (val.length > 0) {
            setCopResidentialData({
              ...copResidentialData,
              poc_id: [val.map((obj) => obj.id)],
            });
          }
        }}
      />

      <FormGroup
        className={`date custom_date_picker ${isFocus2 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDateChange2}
          onShow={() => setIsFous2(true)}
          onHide={handleDateHide2}
          onClear={() => setIsFous2(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          minDate={new Date()}
        />
        <label>
          {localization.nextFollowUpDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus2 && (
          <label className="error date_error">
            {localization.requiredNextFollow}
          </label>
        )}
      </FormGroup>

      <FormGroup
        className={`date custom_date_picker ${isFocus3 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDateChange3}
          onShow={() => setIsFous3(true)}
          onHide={handleDateHide3}
          onClear={() => setIsFous3(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          minDate={new Date()}
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
        />
        <label>
          Expected Closure Date
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus3 && (
          <label className="error date_error">
            {localization.requiredClosureDate}
          </label>
        )}
      </FormGroup>
      <div className="w-100 mb-20">
        <div className="btn-transparent mr-3 d-inline-block">
          <FileUpload
            id="addFollowupUpload"
            accept=".pdf,.png,.jpg,.jpeg,.doc"
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            onChange={(val) =>
              setCopResidentialData({
                ...copResidentialData,
                document: val,
              })
            }
          >
            <span className="btn btn-transparent">
              {localization.uploadSupportingDocument}
            </span>
          </FileUpload>
          &nbsp;
          <label>{` ${localization.supportedFormat}`}</label>
          {/* <label className={`error ${copResidentialData.document === "" ? "error-block" : ""}`}>{localization.uploadQuotationIsRequired}</label> */}
        </div>
      </div>
    </FormSection>
  );
};
